import klass from './Form.module.scss';
import { ButtonAction } from '@services/MarppleShop/shared/components/atoms/ButtonAction/ButtonAction.ts';
import { MainInfoSection } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/section-views/MainInfoSection.ts';
import { SalesInfoSection } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/section-views/SalesInfoSection.ts';
import { StockAndOptionSection } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/section-views/StockAndOptionSection.ts';
import { ProducingInfoSection } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/section-views/ProducingInfoSection.ts';
import { DetailInfoSection } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/section-views/DetailInfoSection.ts';
import { GOODS_TYPE } from '@services/MarppleShop/features/Product/type';
import {
  BaseForm,
  FormSectionCreator,
} from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/BaseForm.ts';
import { DeliveryAndRefundInfoSection } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/section-views/DeliveryAndRefundInfoSection.ts';

export class NewForm extends BaseForm {
  protected override createSections(): FormSectionCreator[] {
    return [
      (store, data) =>
        new MainInfoSection({
          store,
          products_memberships: data.products_memberships ?? [],
          mpsCategories: data.mpsCategories,
          goods_type_id: GOODS_TYPE.PBG,
          is_created_sku: data.is_created_sku,
          is_plus: data.is_plus,
          is_public: data.stores_product?._?.product?.is_public,
          is_studio_worker_admin: data.is_studio_worker_admin,
          is_crew_admin: data.action?.is_crew_admin,
        }),
      (store, data) => new SalesInfoSection({ store, is_created_sku: data.is_created_sku }),
      (store, data) =>
        new StockAndOptionSection({ store, is_created_sku: data.is_created_sku, is_mobile: data.is_mobile }),
      (store, data) => new ProducingInfoSection({ store, is_created_sku: data.is_created_sku }),
      (store, data) => new DetailInfoSection({ store, is_created_sku: data.is_created_sku }),
      (store, data) =>
        new DeliveryAndRefundInfoSection({
          store,
          stores_delivery_companies: data.stores_delivery_companies,
          goods_type_id: data.goods_type_id,
          is_created_sku: data.is_created_sku,
        }),
    ];
  }

  protected override createButtons(): {
    header: ButtonAction[];
    footer: ButtonAction[];
    seeMore?: boolean;
  } {
    return {
      header: [
        new ButtonAction({
          klass: klass.button_temp_save,
          size: this.data.is_mobile ? 'large' : 'small',
          label: '임시저장',
          type: 'line',
        }),
        new ButtonAction({
          klass: klass.button_save,
          size: this.data.is_mobile ? 'large' : 'small',
          label: '등록하기',
          type: 'blue',
        }),
      ],

      footer: [
        new ButtonAction({
          klass: klass.button_temp_save,
          size: this.data.is_mobile ? 'large' : 'small',
          label: '임시저장',
          type: 'line',
        }),
        new ButtonAction({
          klass: klass.button_save,
          size: this.data.is_mobile ? 'large' : 'small',
          label: '등록하기',
          type: 'blue',
        }),
      ],
    };
  }
}
